import {
  API_GET_ACCOUNTS,
  API_POST_SET_ACCOUNT,
  SET_STATE_ACCOUNTS,
  SET_STATE_ACCOUNT,
} from './types';

import { buildApiRequest } from '@/modules/Vuex';

import {
  accountsByUser as apiAcccountsByUser,
  accountSelect as apiAccountSelect,
} from '@/api/routes/accounts';

const accountsModule = {
  state: {
    isFetching: false,
    accounts: {},
    account: {},
  },
  getters: {},
  mutations: {
    [SET_STATE_ACCOUNTS]: (state, accounts) => {
      state.accounts = accounts || [];
    },
    [SET_STATE_ACCOUNT]: (state, account) => {
      state.account = account || {};
    },
  },
  actions: {},
};

buildApiRequest({
  storeModule: accountsModule,
  actionTypes: API_GET_ACCOUNTS,
  apiRoute: apiAcccountsByUser,
});

buildApiRequest({
  storeModule: accountsModule,
  actionTypes: API_POST_SET_ACCOUNT,
  apiRoute: apiAccountSelect,
});

accountsModule.mutations = {
  ...accountsModule.mutations,
  [API_GET_ACCOUNTS.SUCCESS]: (state, payload) => {
    state.accounts = payload?.data.filter((item) => item.user.active_properties_count > 0) || [];
    state.get_accounts = payload;
  },
};

export default accountsModule;
